const PRODUCT_IMAGES_STORAGE_KEY = 'product-images-by-code'

export const getSavedProductImages = (productCode: string): any[] => {
  if (!productCode || typeof window === 'undefined') return []

  try {
    const rawStoredImages = window.localStorage.getItem(
      PRODUCT_IMAGES_STORAGE_KEY
    )
    const imagesByProductCode = rawStoredImages
      ? JSON.parse(rawStoredImages)
      : {}
    const savedImages = imagesByProductCode?.[productCode]

    return Array.isArray(savedImages) ? savedImages : []
  } catch (error) {
    console.warn(
      '[product] Failed to read saved product images from localStorage',
      error
    )
    return []
  }
}

export const saveProductImages = (productCode: string, images: any[]): void => {
  if (
    !productCode ||
    typeof window === 'undefined' ||
    !Array.isArray(images) ||
    images.length === 0
  )
    return

  try {
    const rawStoredImages = window.localStorage.getItem(
      PRODUCT_IMAGES_STORAGE_KEY
    )
    const imagesByProductCode = rawStoredImages
      ? JSON.parse(rawStoredImages)
      : {}

    imagesByProductCode[productCode] = images
    window.localStorage.setItem(
      PRODUCT_IMAGES_STORAGE_KEY,
      JSON.stringify(imagesByProductCode)
    )
  } catch (error) {
    console.warn(
      '[product] Failed to save product images in localStorage',
      error
    )
  }
}
